module.exports = __webpack_public_path__ + "img/diskon.2ac38844.png";